import { useEffect } from 'react';

export const UNSAVED_LEAVE_MESSAGE = '有未儲存的變更，確定要離開？';

/**
 * JRN-09 — browser refresh／close 時提示未儲存變更（純 FE）。
 */
export function useBeforeUnloadWhen(when) {
  useEffect(() => {
    if (!when) return undefined;
    function onBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
    }
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);
}

/**
 * In-app 離開／取消時的 confirm。when=false 時直接放行。
 * @returns {boolean} true＝允許離開
 */
export function confirmDiscardUnsavedChanges(
  when,
  message = UNSAVED_LEAVE_MESSAGE,
) {
  if (!when) return true;
  if (typeof window === 'undefined' || typeof window.confirm !== 'function') {
    return true;
  }
  return window.confirm(message);
}
